import { Injectable } from '@angular/core';
import { MessageService } from '../service-ui/message.service';
import { HttpClient } from '@angular/common/http';
import { StartupService } from '../service-ui/startup.service';
import {AbstractLiveDataService} from './abstract-live-data.service';
import {NotificationsService} from './notifications.service';
import {CarrierServiceMap} from '../../model/CarrierServiceMap';

@Injectable()
export class CarrierServiceMapService extends AbstractLiveDataService<CarrierServiceMap> {

  constructor(private httpa: HttpClient, private messageServicea: MessageService, private startupServicea: StartupService, protected notificationsService: NotificationsService) {
    super(httpa, messageServicea, startupServicea, notificationsService);
    this.notificationsService.setCarrierServiceMapService(this);
    this.notificationsService.startNotification();
  }

  makeObjectInstance(args: any): CarrierServiceMap {
    return new CarrierServiceMap(args);
  }

  getLoggingObjectTypeName(): string {
    return 'CarrierServiceMap';
  }

  supportsParallel(): boolean {
    return false;
  }

  getURLEndPoint(): string {
    return 'carrierservicemap';
  }

  getLinkData(): any[] {
    return [];
  }
}

